import React from 'react';
import {
  Paper,
  Typography,
  Box,
  Button,
  Grid,
  IconButton,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { format } from 'date-fns';
import type { Service } from '../../types';
import { useLanguage } from '../../contexts/LanguageContext';

interface ConfirmationStepProps {
  barberId: number;
  service: Service;
  date: string;
  time: string;
  onConfirm: () => void;
  onBack?: () => void;
  loading: boolean;
}

const ConfirmationStep: React.FC<ConfirmationStepProps> = ({
  service,
  date,
  time,
  onConfirm,
  onBack,
  loading,
}) => {
  const { t } = useLanguage();
  
  return (
    <Box sx={{ width: '100%' }}>
      {onBack && (
        <Box sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
          <IconButton 
            onClick={onBack} 
            sx={{ mr: 2 }}
            aria-label={t('button.back')}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h5">{t('confirmation.title')}</Typography>
        </Box>
      )}
      
      <Paper sx={{ p: 3 }}>
        {!onBack && (
          <Typography variant="h6" gutterBottom>
            {t('confirmation.title')}
          </Typography>
        )}
        
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography>
              <strong>{t('confirmation.service')}:</strong> {service.name}
            </Typography>
            <Typography>
              <strong>{t('confirmation.price')}:</strong> ${service.price}
            </Typography>
            <Typography>
              <strong>{t('service.duration')}:</strong> {service.duration} {t('service.minutes')}
            </Typography>
            <Typography>
              <strong>{t('confirmation.date')}:</strong> {format(new Date(date), 'MMMM d, yyyy')}
            </Typography>
            <Typography>
              <strong>{t('confirmation.time')}:</strong> {time}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={onConfirm}
                disabled={loading}
              >
                {loading ? t('confirm.processing') : t('confirmation.confirm')}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default ConfirmationStep; 